import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=45056230&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=45056230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45056230",
  null
  
)

export default component.exports